var map = {
	"./arrow-left.svg": 3,
	"./arrow-select-rotated.svg": 4,
	"./arrow-select.svg": 5,
	"./arrow-slide-left.svg": 6,
	"./arrow-slide-right.svg": 7,
	"./arrow-white.svg": 8,
	"./arrow.svg": 9,
	"./breakfast-times.svg": 10,
	"./calendar-arrival.svg": 11,
	"./calendar-departure.svg": 12,
	"./cardio.svg": 13,
	"./cardio2.svg": 14,
	"./check-blue.svg": 15,
	"./check-white.svg": 16,
	"./check.svg": 17,
	"./close-black.svg": 18,
	"./cocktail.svg": 19,
	"./coffee.svg": 20,
	"./dropdown-arrow.svg": 21,
	"./facebook.svg": 22,
	"./fullscreen-black.svg": 23,
	"./gallery.svg": 24,
	"./holidaycheck.svg": 25,
	"./home-made.svg": 26,
	"./indoor-pool.svg": 27,
	"./instagram.svg": 28,
	"./location-pin.svg": 29,
	"./location.svg": 30,
	"./logo-signet.svg": 31,
	"./mail.svg": 32,
	"./occupancy.svg": 33,
	"./parking.svg": 34,
	"./period.svg": 35,
	"./phone.svg": 36,
	"./price.svg": 37,
	"./quote-signet.svg": 38,
	"./regional.svg": 39,
	"./room-size.svg": 40,
	"./sample.svg": 41,
	"./sauna.svg": 42,
	"./stay.svg": 43,
	"./trip-advisor.svg": 44,
	"./voucher.svg": 45,
	"./walk.svg": 46,
	"./wine.svg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;